import { useState } from 'react';

// graphql
import { PageInfo, usePlt_TerminalProfitWithdrawalsQuery, useConfirmTerminalProfitWithdrawalMutation } from '@/generated/graphql';
import {
  ITerminalProfitWithdrawalQueryVariable,
  ITerminalProfitWithdrawalTable,
  mapGQLTerminalProfitWithdrawal,
} from '@/shared/interfaces';

// components
import { IModalConfirmationDetails, ConfirmationModal } from '@/components/modal/confirmation';
import { TableTerminalProfitWithdrawals } from './table';

interface IProps {
  refetch: () => void;
}

export const TerminalProfitWithdrawal = ({ refetch }: IProps) => {
  const [confirmTerminalProfitWithdrawal] = useConfirmTerminalProfitWithdrawalMutation();

  const [terminalProfitWithdrawals, setTerminalProfitWithdrawals] = useState<ITerminalProfitWithdrawalTable[]>([]);
  const [terminalProfitWithdrawal, setTerminalProfitWithdrawal] = useState<ITerminalProfitWithdrawalTable | undefined>();

  const [confirmationModal, setConfirmationModal] = useState<IModalConfirmationDetails>({
    isOpen: false,
    title: 'Are you sure ?',
    messages: ['You want to confirm this transaction'],
  });

  const [terminalProfitWithdrawalsQueryVariable, setTerminalProfitWithdrawalsQueryVariable] =
    useState<ITerminalProfitWithdrawalQueryVariable>({
      first: 25,
    });

  const [terminalProfitWithdrawalsPageInfo, setTerminalProfitWithdrawalsPageInfo] = useState<PageInfo>();
  const [terminalProfitWithdrawalsTotalCount, setTerminalProfitWithdrawalsTotalCount] = useState<number>(0);

  const terminalProfitWithdrawalsQuery = usePlt_TerminalProfitWithdrawalsQuery({
    variables: terminalProfitWithdrawalsQueryVariable,
    notifyOnNetworkStatusChange: true,
    onCompleted(data) {
      const mappedData = data.terminalProfitWithdrawals.nodes.map((x) => mapGQLTerminalProfitWithdrawal(x));

      const mappedTableData: ITerminalProfitWithdrawalTable[] = mappedData.map((x) => ({
        id: x.id,
        amount: x.amount,
        status: x.status,
        cashierUsername: x.cashier.user.username,
        adminUsername: x.admin.user.username,
        createdAt: x.createdAt,
      }));

      setTimeout(() => {
        setTerminalProfitWithdrawals(mappedTableData);
        setTerminalProfitWithdrawalsPageInfo(data.terminalProfitWithdrawals.pageInfo);
        setTerminalProfitWithdrawalsTotalCount(data.terminalProfitWithdrawals.totalCount);
      }, 100);
    },
  });

  const transactionAction = (actionType: string, data: ITerminalProfitWithdrawalTable) => {
    switch (actionType) {
      case 'confirm':
        setTerminalProfitWithdrawal(data);
        setConfirmationModal((prev) => ({ ...prev, isOpen: true }));
        break;
      default:
        break;
    }
  };

  const confirmTransaction = () => {
    if (terminalProfitWithdrawal) {
      setConfirmationModal((prev) => ({ ...prev, isOpen: false }));
      confirmTerminalProfitWithdrawal({
        variables: {
          confirmTerminalProfitWithdrawalId: terminalProfitWithdrawal.id,
        },
        onCompleted: () => {
          terminalProfitWithdrawalsQuery.refetch();
          refetch();
        },
      });
    }
  };

  return (
    <>
      <TableTerminalProfitWithdrawals
        rows={terminalProfitWithdrawals}
        setTerminalProfitWithdrawalQueryVariable={setTerminalProfitWithdrawalsQueryVariable}
        terminalProfitWithdrawalQueryVariable={terminalProfitWithdrawalsQueryVariable}
        totalCount={terminalProfitWithdrawalsTotalCount}
        pageInfo={terminalProfitWithdrawalsPageInfo}
        getTerminalProfitWithdrawalLoading={terminalProfitWithdrawalsQuery.loading}
        transactionAction={transactionAction}
      />
      <ConfirmationModal
        modalDetails={confirmationModal}
        setModalDetails={setConfirmationModal}
        confirm={confirmTransaction}
        confirmText={'confirm'}
      />
    </>
  );
};
